"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeisureReviewListPageRequestSchema = exports.LeisureReviewListPageQuery = exports.LeisureReviewListPageResources = void 0;
var zod_1 = require("zod");
var sort_option_1 = require("../sort-option");
exports.LeisureReviewListPageResources = zod_1.z.object({
    /** 레저 상품그룹 ID */
    productGroupId: zod_1.z.number(),
});
exports.LeisureReviewListPageQuery = zod_1.z.object({
    /** 페이지 번호 */
    page: zod_1.z.number().optional(),
    /** 후기 사진만 보기 */
    isPhotoReviewOnly: zod_1.z.boolean().optional(),
    /** 후기 플랫폼 정렬 */
    sort: sort_option_1.ReviewPlatformSortCode.optional(),
});
exports.LeisureReviewListPageRequestSchema = zod_1.z.object({
    resources: exports.LeisureReviewListPageResources,
    query: exports.LeisureReviewListPageQuery,
});
